"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functions = require("../../../utilities/functions");

var _QuestionName = require("./QuestionName");

var _QuestionName2 = _interopRequireDefault(_QuestionName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["question", "unique", "value", "name"],

  components: {
    QuestionName: _QuestionName2.default
  },

  data: function data() {
    return {
      answer: "",
      selected: "",
      rows: 1
    };
  },
  mounted: function mounted() {
    this.answer = this.value || "";
    this.selected = this.getSelectedValue(this.answer);
    this.rows = this.getRowsCountByTextLength(this.answer.length);
  },


  watch: {
    selected: function selected(value) {
      this.$emit("update", this.question.unique, value);
    },
    answer: function answer() {
      if (!(0, _functions.isMobile)()) {
        return;
      }

      if (this.answer.length === 0) {
        this.rows = 1;
        return;
      }

      var rowsCountByTextLength = this.getRowsCountByTextLength(this.answer.length);
      this.rows = this.rows < rowsCountByTextLength ? rowsCountByTextLength : this.rows;
    }
  },

  methods: {
    onAnswerChange: function onAnswerChange(event) {
      this.answer = event.target.value;
      this.selected = this.getSelectedValue(event.target.value);
    },
    addRow: function addRow() {
      if ((0, _functions.isMobile)()) {
        this.rows = this.rows + 1;
      }
    },
    getSelectedValue: function getSelectedValue(value) {
      return this.question.type == "numeric" && value !== null ? parseFloat(value.replace(",", ".")) : value;
    },
    getRowsCountByTextLength: function getRowsCountByTextLength(textLength) {
      var maxCharsPerRow = 38;
      var defaultRowsCount = 1;

      if (textLength < maxCharsPerRow) {
        return defaultRowsCount;
      }

      return Math.ceil(textLength / maxCharsPerRow);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/elements/TextBox.vue
// module id = V19l
// module chunks = 0 1